module.exports = __webpack_public_path__ + "img/wishes.fa9f64ce.jpg";